<div class="walkthrough-step-container">
  <!-- ICON / BG -->
  <div class="background">
    <ion-img class="background-icon" src="assets/images/walkthrough/main-intro-icon.svg"></ion-img>

    <p class="background-text header-title">Hello!</p>
  </div>

  <!-- CONTENT -->
  <div class="content">
    <h1 class="content-title header-title">Welcome to <br /><span>Ready to Serve<sup>TM</sup>.</span></h1>

    <p class="content-subtitle">Let's get acquainted, shall we...</p>
    <br />
    <br />
    <br />
    <p class="content-description-title">Important Features</p>
    <p class="content-description">
      Before you begin please get familiar with our key<br />
      features which will help you and your customers<br />
      have the most delicious dining experience.
    </p>
  </div>
</div>
